import React, { useState, useEffect, useRef } from 'react';

// Minimal type for Wake Lock Sentinel
interface WakeLockSentinel {
  released: boolean;
  release: () => Promise<void>;
  addEventListener: (type: 'release', listener: () => void) => void;
  removeEventListener: (type: 'release', listener: () => void) => void;
}

const KeepScreenAwake: React.FC = () => {
  const [isChecked, setIsChecked] = useState(false);
  const wakeLockRef = useRef<WakeLockSentinel | null>(null);
  const [wakeLockSupported, setWakeLockSupported] = useState(false);

  const requestWakeLock = async () => {
    try {
      // Bruk optional chaining i stedet for custom Navigator-type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const wakeLock = (navigator as any)?.wakeLock;
      if (wakeLock?.request) {
        wakeLockRef.current = await wakeLock.request('screen');
        wakeLockRef.current?.addEventListener('release', () => {
        });
      }
    } catch (err) {
      console.error('Feil ved forespørsel om Wake Lock:', err);
    }
  };

  const releaseWakeLock = async () => {
    try {
      if (wakeLockRef.current) {
        await wakeLockRef.current.release();
        wakeLockRef.current = null;
      }
    } catch (err) {
      console.error('Feil ved deaktivering av Wake Lock:', err);
    }
  };

  useEffect(() => {
    if (isChecked) {
      requestWakeLock();
    } else {
      releaseWakeLock();
    }

    return () => {
      releaseWakeLock();
    };
  }, [isChecked]);


  /* Check if browser support wakeLock API */
  const isWakeLockSupported = () => {
    return 'wakeLock' in navigator;
  }

  useEffect(() => {
    if (isWakeLockSupported()) {
      setWakeLockSupported(true);
    }
  }, []);

  return (
      <>
        {wakeLockSupported && (
          <div className="p-3 rounded bg-brown-50 mb-6">
              <div className="flex justify-between">
                  <h2 className="text-lg laptop:text-xl">Behold skjermen på</h2>
                  <div>
                      <input type="checkbox" id="keepscreen" className="ofg-toggleswitch" checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}/>
                      <label htmlFor="keepscreen">
                          <span className="sr-only">Huk av for å beholde skjermen på</span>
                      </label>
                  </div>
              </div>
              <p className="text-sm">
                  Gjør at skjermen ikke skrur seg av.
              </p>
          </div>
        )}
      </>
  );
};

export default KeepScreenAwake;
